export default "__VITE_ASSET__BgIuUA2r__"